import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalPlaceholderComponent } from '../modal-placeholder.component';
// import { HelpersService } from '../../../services/helpers.service';
import { GlobalModalService } from '../../../services/global-modal.service';

@Component({
  selector: 'sms-terms-modal',
  imports: [ModalPlaceholderComponent],
  templateUrl: './sms-terms-modal.component.html',
  styleUrl: './sms-terms-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsTermsModalComponent {
  constructor(
      // private helpersService: HelpersService,
      private globalModalService: GlobalModalService,
      private activeModal: NgbActiveModal
    ) { }

  close() {
    this.globalModalService.setScrollingInPage();
    this.activeModal.close()
  }
}
